<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Placówki</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-btn slot="activator" color="primary" dark class="mb-3 ml-3">Dodaj placówkę</v-btn>
			<v-card>
				<v-card-title>
					<span class="headline" v-if="isEdited"> Edycja placówki </span>
					<span class="headline" v-else> Dodaj nową placówkę </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-form ref="form"
							v-model="valid"
							lazy-validation>

							<v-layout wrap>
								<v-flex xs12 sm6 md6>
									<v-text-field v-model="editedItem.name"
										browser-autocomplete="off"
										:rules="validation.nameRules"
										name="name"
										label="Nazwa"
										aria-label="agency name"
										for="agencies-view-name"
										id="agencies-view-name">
									</v-text-field>
								</v-flex>
								<v-flex xs12 sm6 md3>
									<v-autocomplete :items="agencyTypes"
										label="Typ"
										:rules="validation.typeRules"
										name="type"
										for="agencies-view-type"
										id="agencies-view-type"
										v-model="editedItem.type"
										aria-label="agency type"
										item-text="name"
										item-value="name"
										v-on:change="agencyTypeChosen(editedItem)"
									></v-autocomplete>
									<span>{{ vErrors.first("type") }}</span>
								</v-flex>
								<v-flex xs12 sm6 md3>
									<v-autocomplete :items="currencies"
										label="Waluta"
										item-text="code"
										item-value="id"
										name="currency"
										aria-label="agency currency"
										for="agencies-view-currency"
										id="agencies-view-currency"
										v-model="editedItem.currency"
										clearable>
									</v-autocomplete>
								</v-flex>
							</v-layout>
							<v-layout wrap v-if="editedItem.type === 'Ambasada' || editedItem.type === 'Inna placówka'">
								<v-flex xs12 sm6 md12>
									<v-autocomplete
										v-model="editedItem.countryList"
										:items="accreditationCountries"
										item-text="name"
										item-value="id"
										:rules="validation.countryRules"
										label="Kraje"
										name="countriesAccreditation"
										aria-label="agency accreditation countries"
										for="agencies-view-countries-accreditation"
										id="agencies-view-countries-accreditation"
										clearable
										multiple
										chips
										deletable-chips
									></v-autocomplete>
								</v-flex>
							</v-layout>
							<v-layout wrap v-else>
								<v-flex xs12 sm6 md12>
									<v-autocomplete
										disabled
										label="Kraje"
										name="countriesAccreditation"
										aria-label="agency accreditation countries"
										for="agencies-view-countries-accreditation"
										id="agencies-view-countries-accreditation"
										chips
									></v-autocomplete>
								</v-flex>
							</v-layout>
							<div v-if="errorMessage" style="color:red;">
								{{errorMessage}}
							</div>
						</v-form>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close">Anuluj</v-btn>
					<v-btn color="primary" flat  @click="save">{{
						isEdited ? "Zapisz" : "Utwórz"}}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-layout align-center justify-center row>
			<v-flex xs3>
				<v-autocomplete
					class="ma-2"
					label="Nazwa placówki"
					aria-label="agency name"
					v-model="dataTable.searchFields.agencyId"
					:items="agencyNames"
					item-text="name"
					item-value="id"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs2>
				<v-autocomplete
					class="ma-2"
					:items="agencyTypes"
					label="Typ placówki"
					aria-label="agency type"
					for="agencies-view-agency-type"
					id="agencies-view-agency-type"
					item-text="name"
					item-value="value"
					v-model="dataTable.searchFields.embassy"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs2>
				<v-autocomplete
					class="ma-2"
					:items="accreditationCountries"
					label="Kraj akredytacji"
					aria-label="agency accreditation country"
					for="agencies-view-accreditation-country"
					id="agencies-view-accreditation-country"
					item-text="name"
					item-value="id"
					v-model="dataTable.searchFields.accreditationCountryId"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs4>
				<v-layout align-center justify-center row>
					<v-btn @click="buildNewSearch" color="primary" dark class="mb-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="mb-2">Resetuj</v-btn>
					<v-btn @click="exportData" color="primary" dark class="mb-2 mr-3">Eksportuj</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<td class="text-xs-left">{{ props.item.name }}</td>
				<td class="text-xs-left">{{ getItemType(props.item) }}</td>
				<td class="text-xs-left">{{ getCurrencyCode(props.item) }}</td>
				<td class="text-xs-left">
					{{Object.values(props.item.countryList).join(", ")}}
				</td>
				<td class="text-xs-left">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="editItem(props.item)" >
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Edytuj</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="goToProfile(props.item.id)">
								<v-icon v-on="on">
									location_city
								</v-icon>
							</v-btn>
						</template>
						<span>Podgląd placówki</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="deleteItem(props.item)" >
								<v-icon color="lightred" v-on="on">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "@/api";
	import {Currency} from "@/api/generated/Currency";
	import {Agency} from "@/api/generated/Agency";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {Pagination} from "@/utils/PaginationUtils";
	import {AccreditationCountry} from "@/api/generated/AccreditationCountry";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "AgenciesView",

    mixins: [Filters],

		watch: {
			"dataTable.pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			},

			dialog(val) {
				!val && (this.editedIndex = -1) && (this.editedItem = {});
			},
		},

		computed: {
			isEdited() {
				return this.editedIndex !== -1;
			},
		},

		data() {
			return {
				dataTable: {
					searchFields: Pagination.initSearchedFields([
						"agencyId",
						"embassy",
						"accreditationCountryId"
					]),
					tableHeaders: [
						{
							text: "Placówka",
							sortable: true,
							value: "name"
						},
						{
							text: "Typ",
							sortable: true,
							value: "type"
						},
						{
							text: "Waluta",
							sortable: true,
							value: "currency"
						},
						{
							text: "Kraje",
							sortable: false,
						},
						{
							text: "Akcje",
							sortable: false,
						},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
					},
					search: "",
				},

				valid: true,

				agencyTypes: [
					{name: "Ambasada", value: true},
					{name: "Inna placówka", value: false}],

				agencyNames: [],

				currencies: [],

				accreditationCountries: [],

				dialog: false,

				nameDuplicated: false,

				countryDuplicated: false,

				errorMessage: null,

				editedItem: {},

				editedIndex: -1,

				validation: {
					nameRules: [
						v => !!v || "Nazwa jest wymagana",
					],
					typeRules: [
						v => !!v || "Typ placówki jest wymagany",
					],
					countryRules: [
						v => !!v || "Podanie kraju akredytacji jest obowiązkowe",
					],
				},
			};
		},

		methods: {
			exportData () {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				let path = "/agency/export?search=" + this.dataTable.search
					+ "&page=" + this.dataTable.pagination.page +
					"&result=" + this.dataTable.pagination.rowsPerPage;
				ExportUtils.sendExportRequest(path, this);
			},

			getItemList() {
				let sort = this.buildSort();
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				Api.get(this,
					"/agency/list?search=" + this.dataTable.search
						+ "&page=" + this.dataTable.pagination.page +
						"&result=" + this.dataTable.pagination.rowsPerPage +
						"&sort=".concat(sort), response => {
							this.dataTable.itemList = response.itemList;
							this.dataTable.itemCount = response.itemCount;
						});
			},

			getCurrencyCode(item) {
				if (item.currency === null || item.currency === undefined) {
					return "";
				} else {
					return item.currency.code;
				}
			},

			buildSort() {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			getItemType(item) {
				if (item.embassy) {
					return this.agencyTypes[0].name;
				}
				return this.agencyTypes[1].name;
			},

			clearFields() {
			},

			buildNewSearch() {
				this.dataTable.search = this.buildSearch();
				this.getItemList();
			},

			resetSearch() {
				Pagination.resetSearch(this.dataTable.searchFields);
				this.getItemList();
			},

			buildSearch() {
				return Pagination.buildSearchCriteria(this.dataTable.searchFields, false);
			},

			goToProfile (id) {
				this.$router.push("/app/agency-profile/" + id);
			},

			agencyTypeChosen(editedItem) {
				editedItem.countryList = undefined;
			},

			editItem(item) {
				this.editedIndex = this.dataTable.itemList.indexOf(item);
				this.editedItem = Object.assign({}, item);
				if (this.editedItem.currency !== null) {
					this.editedItem.currency = this.editedItem.currency.id;
				}
				this.editedItem.countryList = Object.keys(item.countryList).map(key => parseInt(key));
				if (item.embassy) {
					this.editedItem.type = this.agencyTypes[0].name;
				} else {
					this.editedItem.type = this.agencyTypes[1].name;
				}
				this.dialog = true;
			},

			deleteItem(item) {
				const index = this.dataTable.itemList.indexOf(item);
				this.$confirm("Czy na pewno chcesz usunąć placówkę?", {
					icon: 'delete',
					title: 'Usuwanie placówki',
					color: 'lightred',
					width: 500
				})
					.then(response => {
						if (response) {
							Agency.delete(this, item.id, successResponse => {
									this.dataTable.itemList.splice(index, 1);
									this.$messagesBus.$emit("success", "Placówka została pomyślnie usunięta", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć placówki", errorResponse);
								});
						}
					});
			},

			close() {
				this.dialog = false;
				this.editedIndex = -1;
				this.editedItem = {};
				this.$refs.form.reset();
				this.$refs.form.resetValidation();
				this.errorMessage = "";
			},

			save() {
				this.errorMessage = null;
				if (!this.$refs.form.validate()) {
					return;
				}
				let idList = this.editedItem.countryList;
				this.editedItem.embassy = this.editedItem.type === "Ambasada";
				let formData = {
					id: this.editedItem.id,
					name: this.editedItem.name,
					embassy: this.editedItem.embassy,
					currencyId: this.editedItem.currency,
					countryIdList: idList,
				};
				if (this.editedItem.id === undefined) {
					Agency.post(this, formData, successResponse => {
						this.dialog = false;
						this.getItemList();
						this.$refs.form.reset();
						this.errorMessage = "";
						this.$messagesBus.$emit("success", "Placówka została pomyślnie dodana", successResponse);
					}, errorResponse => {
						this.errorMessage = errorResponse.message;
						this.$messagesBus.$emit("error", "Nie udało się dodać placówki", errorResponse);
					});
				} else {
					Agency.put(this, formData, successResponse => {
						this.dialog = false;
						this.getItemList();
						this.$refs.form.reset();
						this.errorMessage = "";
						this.$messagesBus.$emit("success", "Placówka została pomyślnie zapisana", successResponse);
					}, errorResponse => {
						this.errorMessage = errorResponse.message;
						this.$messagesBus.$emit("error", "Nie udało się zapisać placówki", errorResponse);
					});
				}
			},
		},

		created () {
			AccreditationCountry.get(this, successResponse => {
					this.accreditationCountries = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się pobrać listy krajów", errorResponse);
				});

			Agency.getNames(this, successResponse => {
					this.agencyNames = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się pobrać nazw placówek", errorResponse);
				});

			Currency.get(this, successResponse => {
					this.currencies = successResponse;
				},
				errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się pobrać walut", errorResponse);
				});

      this.dataTable.searchFields = this.retrieveFilters(this.dataTable.searchFields);
      this.dataTable.pagination = this.retrievePagination(this.dataTable.pagination);
		},
	};
</script>

<style scoped>

</style>
